module.exports = __webpack_public_path__ + "img/patient_list.7f379054.svg";